const faqs = [
  {
    question: "Does Wisconsin have its own passport agency?",
    answer:
      "Wisconsin does not have a state-level passport agency. The nearest regional passport agency for all Wisconsin residents is the Chicago Passport Agency, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604. Distances from Wisconsin cities range from 65 miles (Racine/Kenosha) to over 200 miles (Green Bay, Eau Claire). Fast Passport Center's registered couriers deliver directly to Chicago so Wisconsin residents don't have to make the drive.",
  },
  {
    question: "How fast can I get a passport in Wisconsin?",
    answer:
      "With Fast Passport Center's courier service, Wisconsin travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 2 to 9 business days. Routine processing through the post office typically takes 8 to 11 weeks. Wisconsin has no local passport agency, which makes courier service the fastest available option for all Wisconsin residents.",
  },
  {
    question: "Is it worth driving to Chicago for a passport from Wisconsin?",
    answer:
      "For most Wisconsin residents, driving to Chicago is not worth it. The Chicago Passport Agency only accepts visitors with pre-scheduled appointments and turns away walk-ins — even if you drove 200 miles. Fast Passport Center pre-secures courier submission slots, ensuring your documents are accepted without you needing to travel. For Green Bay residents, the roundtrip drive is over 6 hours. For Madison residents, it is nearly 5 hours. Our service eliminates this entirely.",
  },
  {
    question: "Where can I get my passport application accepted in Wisconsin?",
    answer:
      "Passport acceptance facilities in Wisconsin include USPS post offices, county clerk offices, and city hall locations. Major options include the Milwaukee County Clerk, Milwaukee Main Post Office, Dane County Clerk (Madison), Green Bay Main Post Office, and Racine County Clerk. Appointments are required at most locations. Fast Passport Center helps you find the nearest facility and can handle renewal submissions without any in-person visit.",
  },
  {
    question: "Can I get a passport for a Canada trip from Wisconsin?",
    answer:
      "Land and sea crossings to Canada may use a REAL ID, passport card, or passport book. Air travel to Canada requires a passport book. For Wisconsin residents near the border (Superior, Ashland, Hurley), a passport book is strongly recommended for the most hassle-free crossing experience.",
  },
  {
    question: "What documents do I need for a first-time passport in Wisconsin?",
    answer:
      "You'll need Form DS-11, a certified Wisconsin birth certificate (ordered from the WI Department of Health Services), a valid Wisconsin driver's license or state ID, two identical passport photos, and payment. All first-time applicants must appear in person at an acceptance facility. Fast Passport Center provides a complete checklist and can schedule your appointment at a convenient location.",
  },
];

export { faqs };

export default function WisconsinFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Wisconsin Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Wisconsin.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}